import { render, staticRenderFns } from "./order-company-save.vue?vue&type=template&id=bff014ae"
import script from "./order-company-save.vue?vue&type=script&lang=js"
export * from "./order-company-save.vue?vue&type=script&lang=js"
import style0 from "./order-company-save.vue?vue&type=style&index=0&id=bff014ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports